import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06cbab34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 d-flex flex-column px-10 pb-10 pt-10" }
const _hoisted_2 = {
  key: 0,
  class: "card-body d-flex flex-column px-0 pt-0"
}
const _hoisted_3 = { class: "w-100 d-flex flex-column px-10 pb-10 pt-10" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href", "download"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-10 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bolder" }, "Choose Your Plan")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PlanColumnView = _resolveComponent("PlanColumnView")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loadingDetails)
      ? (_openBlock(), _createBlock(_component_el_skeleton, { key: 0 }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_skeleton, {
                variant: "text",
                rows: 6,
                animated: ""
              })
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.hasSubscription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (!_ctx.loadingInvoices)
                    ? (_openBlock(), _createBlock(_component_DataTable, {
                        key: 0,
                        "table-data": _ctx.invoiceLists,
                        "table-header": _ctx.headers
                      }, {
                        "cell-number": _withCtx(({ row: invoice }) => [
                          _createElementVNode("a", {
                            href: invoice?.hosted_invoice_url,
                            target: "_blank",
                            class: "text-gray-600 text-hover-primary"
                          }, _toDisplayString(invoice.number), 9, _hoisted_4)
                        ]),
                        "cell-amount": _withCtx(({ row: invoice }) => [
                          _createTextVNode(_toDisplayString(_ctx.moneyFormat(invoice.total)), 1)
                        ]),
                        "cell-status": _withCtx(({ row: invoice }) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", {
                      'badge-light-success': invoice.status === 'paid',
                    }])
                          }, _toDisplayString(invoice.status), 3)
                        ]),
                        "cell-date": _withCtx(({ row: invoice }) => [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(invoice.created, 'DD/MM/YYYY')), 1)
                        ]),
                        "cell-action": _withCtx(({ row: invoice }) => [
                          _createElementVNode("a", {
                            href: invoice.invoice_pdf,
                            download: `${invoice.number}.pdf`,
                            class: "btn btn-sm btn-light btn-active-light-primary"
                          }, " Download ", 8, _hoisted_5)
                        ]),
                        _: 1
                      }, 8, ["table-data", "table-header"]))
                    : (_openBlock(), _createBlock(_component_el_skeleton, {
                        key: 1,
                        rows: 5,
                        animated: ""
                      }))
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_6,
                _createVNode(_component_PlanColumnView)
              ], 64))
        ], 64))
  ]))
}